import api from './api';

export const departmentService = {
  // Get all departments
  getAll: async () => {
    const response = await api.get('/departments');
    return response.data;
  },

  // Get department by ID
  getById: async (id) => {
    const response = await api.get(`/departments/${id}`);
    return response.data;
  },

  // Create new department
  create: async (departmentData) => {
    const response = await api.post('/departments', departmentData);
    return response.data;
  },

  // Update department
  update: async (id, departmentData) => {
    const response = await api.put(`/departments/${id}`, departmentData);
    return response.data;
  },

  // Delete department
  delete: async (id) => {
    await api.delete(`/departments/${id}`);
  },

  // Get slim member list (id, firstName, lastName, position) — no PII
  getMembers: async (id) => {
    const response = await api.get(`/departments/${id}/members`);
    return response.data;
  },
};